__turbopack_context__.v({
  "body": "EFjB8q_body",
  "label": "EFjB8q_label",
  "mark": "EFjB8q_mark",
  "markSlot": "EFjB8q_markSlot",
  "row": "EFjB8q_row",
  "text": "EFjB8q_text",
});
